
import { Component, Vue, Prop } from 'vue-property-decorator'
import { WinClientClient } from '@/api'
import _ from 'lodash'
import BaseEditor from '@/views/BaseEditor'
import FileUpload from 'vue-upload-component'
import request from '@/utils/request'

@Component({
  name: 'WinClientEditor',
  components: {
    FileUpload
  }
})
export default class extends BaseEditor {
  public constructor() {
    super()
    this.client = new WinClientClient()
    this.data = {}
    this.rules = {
      version: [{ required: true, message: '版本号是必填项', trigger: 'blur' }],
      url: [{ required: true, message: '链接地址是必填项', trigger: 'blur' }]
    }
  }

  public async reset() {
    this.data = {
      id: undefined,
      version: undefined,
      url: undefined,
      changelog: 'http://www.xjjnxd.com:8080/client/about',
      mandatory: true
    }
  }

  protected generateData(): any {
    const data = _.pick(this.data, [
      'version',
      'url',
      'changelog',
      'mandatory'
    ])
    return this.clearData(data)
  }

  async handleFileUpload(data: any) {
    if (this.validateFile(data.file)) {
      try {
        const formData = new FormData()
        formData.append('file', data.file)
        formData.append('type', data.file.type)
        const url = await request({
          url: '/minio/cng-client-update/' + data.file.name,
          method: 'post',
          data: formData
        })
        this.data.url = url
      } catch (e) {
        console.log(e)
      }
    }
  }

  validateFile(file: any) {
    console.log(file.type)
    const isZIP =
      'application/x-zip-compressed|application/x-msdownload'.indexOf(
        file.type
      ) > -1
    if (!isZIP) {
      this.$message.error('上传文件只能是ZIP或者EXE格式!')
    }
    return isZIP
  }
}
